<template>
  <div v-if="hasAnyPermission('workflows-view')">
    <div class="py-4 container-fluid">
      <ToastPrime position="bottom-left" />
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <a class="d-flex align-items-center me-3" style="cursor: pointer" @click.prevent="$router.go(-1)">
                    <i class="pi pi-chevron-left text-dark mb-0" style="font-size: 1rem"></i>
                  </a>
                  <h5 class="mb-0">Edit Workflow</h5>
                </div>
                <div class="d-flex align-items-center">
                  <!-- <ButtonPrime class="me-2" label="Back" size="small" severity="primary" @click.prevent="$router.go(-1)" />  -->
                  <ButtonPrime
v-if="hasAnyPermission('workflows-update')" severity="contrast" raised size="small" label="Save" class="px-4" :disabled="field.onLoad || field.onLoadSave"
                    @click="save">
                    <span v-if="field.onLoadSave"><i class="fas fa-spinner fa-spin"></i>&nbsp;Please wait</span>
                    <span v-else>Save</span>
                  </ButtonPrime>
                </div>
              </div>
              <div class="mb-3">
                <label for="workflow_code">Workflow Code</label>
                <Skeleton v-if="field.onLoad || field.onLoadSave" height="2rem" class="mb-2"></Skeleton>
                <InputText v-else id="workflow_code" :value="field.data.code" placeholder="Workflow" disabled fluid />
              </div>
              <div class="mb-3">
                <label for="description">Description <span class="text-danger">*</span></label>
                <Skeleton v-if="field.onLoad || field.onLoadSave" height="2rem" class="mb-2"></Skeleton>
                <InputText
v-else id="description" v-model="field.data.description" placeholder="Workflow"
                  :class="`${(field.errorMessage.description && field.data.description.trim() == '') ? 'border-danger' : ''}`"
                  fluid />
                <small
v-if="field.errorMessage.description && field.data.description.trim() == ''"
                  class="text-danger">{{ field.errorMessage.description }}</small>
              </div>
              <div class="mb-3">
                <label for="status">Status <span class="text-danger">*</span></label>
                <Skeleton v-if="field.onLoad || field.onLoadSave" height="2rem" class="mb-2"></Skeleton>
                <SelectPrime
v-else id="status" v-model="field.data.status" :options="statusOpts" option-label="label"
                  option-value="value" placeholder="Please choose status"
                  :invalid="field.errorMessage.status && field.data.status === ''" class="w-full md:w-56" fluid />
                <small v-if="field.errorMessage.status && field.data.status.trim() == ''" class="text-danger">{{
                  field.errorMessage.status }}</small>
              </div>
              <div class="mb-3">
                <label for="source_type">Source Type <span class="text-danger">*</span></label>
                <Skeleton v-if="field.onLoad || field.onLoadSave" height="2rem" class="mb-2"></Skeleton>
                <SelectPrime
v-else id="source_type" v-model="field.data.source_type" :options="sourceTypeOpt"
                  option-label="label" option-value="value" placeholder="Please choose source type"
                  :invalid="field.errorMessage.source_type && field.data.source_type === ''" class="w-full md:w-56"
                  fluid disabled />
                <small
v-if="field.errorMessage.source_type && field.data.source_type.trim() == ''"
                  class="text-danger">{{ field.errorMessage.source_type }}</small>
              </div>
              
              <div class="mb-5">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <label for="source" class="font-semibold mb-0">Source <span class="text-danger">*</span></label>
                  <ButtonPrime
v-if="field.data.source && !field.onLoad && !field.onLoadSave" type="button" label="Beautify JSON" icon="pi pi-code" size="small"
                    text @click="beautifyJson" />
                </div>
                <Skeleton v-if="field.onLoad || field.onLoadSave" height="20rem" class="mb-2"></Skeleton>
                <PrimeTextarea
v-else id="source" v-model="field.data.source" placeholder="Enter JSON Source..." fluid
                  :class="`${(field.errorMessage.source && !field.data.source) ? 'border-danger' : ''}`" rows="15"
                  style="font-family: monospace; font-size: 12px;" />
                <small v-if="field.errorMessage.source" class="text-danger">{{
                  field.errorMessage.source }}</small>
              </div>

              <!-- HEADER CONDITION -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0">Condition</h5>
                <div class="col-4 d-flex justify-content-center">
                  <IconField class="w-100">
                    <InputIcon class="pi pi-search" />
                    <InputText
v-model="field.search" type="text" size="small" placeholder="Search Condition"
                      class="rounded-pill w-100" />
                  </IconField>
                </div>
                <div>
                  <!-- <ButtonPrime label="Add New" size="small" severity="primary" @click="openAddModal" :disabled="modal.onLoad"></ButtonPrime> -->
                  <button v-if="hasAnyPermission('workflows-add-condition')" type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddModal">Add</button>
                </div>
              </div>
              <div style="height: 450px; overflow-y: auto">
                <DataTable
:value="filteredConditions" removable-sort scrollable scroll-height="flex"
                  table-style="min-width: 50rem">
                  <Column header="Condition" header-class="bg-light" sortable>
                    <template #body="row">
                      <Skeleton v-if="field.onLoad" />
                      <span v-else>{{ row.data.condition }}</span>
                    </template>
                  </Column>
                  <Column
header="" header-class="bg-light" :style="{ width: '120px' }"
                    :body-style="{ width: '120px', padding: '0' }">
                    <template #body="row">
                      <Skeleton v-if="field.onLoad" />
                      <div v-else-if="row.data.condition">
                        <ButtonPrime
v-if="hasAnyPermission('workflows-edit-condition')" v-tooltip.top="'Edit Condition'" icon="pi pi-pencil" outlined rounded
                          size="small" @click="openEditModal(row.data)" />
                        <ButtonPrime
v-if="hasAnyPermission('workflows-remove-condition')" v-tooltip.top="'Delete Condition'" icon="pi pi-trash" outlined rounded
                          severity="danger" size="small" style="margin-left: 5px;"
                          @click="RemoveCondition(row.data.id)" />
                        <ButtonPrime v-slot="slotProps" as-child outlined rounded size="small">
                          <RouterLink
v-tooltip.top="'Go to diagram'" style="margin-left: 5px;"
                            :to="{ name: 'Workflow Diagram', params: { wfcCode: row.data.wfc_code } }" class="p-2"
                            :class="slotProps.class"><i class="pi pi-chart-line"></i></RouterLink>
                          <!-- <a :href="workflowDiagramUrl(row.data.wfc_code)" target="_blank" rel="noopener noreferrer" class="p-2" :class="slotProps.class" v-tooltip.top="'Go to diagram'" style="margin-left: 5px;">
                            <i class="pi pi-chart-line"></i>
                          </a> -->
                        </ButtonPrime>
                      </div>
                      <div v-else class="m-4"><span /></div>
                    </template>
                  </Column>
                  <template #empty>
                    <div class="text-center py-4">
                      <img src="/no_data.png" alt="No Data" style="width: 100px; height: 100px; opacity: 0.5;" />
                      <p class="text-muted mt-2">No Conditions found</p>
                    </div>
                  </template>
                </DataTable>
              </div>

              <DialogPrime v-model:visible="modal.visible" :header="modal.title" style="width: 30rem; margin: 10px;">
                <div class="mb-2">
                  <label for="condition_modal" class="font-semibold">Condition <span
                      class="text-danger">*</span></label>
                  <InputText
id="condition_modal" v-model="modal.data.condition" placeholder="Condition"
                    :class="`${(modal.errorMessage.condition && modal.data.condition.trim() == '') ? 'border-danger' : ''}`"
                    fluid />
                  <small v-if="modal.errorMessage.condition && modal.data.condition.trim() == ''" class="text-danger">{{
                    modal.errorMessage.condition }}</small>
                </div>

                <template #footer>
                  <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
                    <ButtonPrime
type="button" label="Cancel" severity="danger" class="px-4 border-0" raised
                      size="small" :disabled="modal.onLoad" @click="modal.visible = false"></ButtonPrime>
                    <ButtonPrime
v-if="canSaveCondition" type="button" severity="contrast" raised size="small" label="Save" class="px-4"
                      :disabled="modal.onLoad || !modal.data.condition" @click="saveCond()">
                      <template v-if="modal.onLoad" #icon>
                        <i class="fas fa-spinner fa-spin me-2"></i>
                      </template>
                    </ButtonPrime>
                  </div>
                </template>
              </DialogPrime>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import NoAccess from "@/components/NoAccess.vue";
import workflowService from "@/services/generalSettings/workflowService";
import api from "@/helpers/api";

export default {
  components: {
    NoAccess,
  },
  data() {
    return {
      searchQuery: "",
      field: {
        title: "",
        search: "",
        data: {
          workflow_condition: [{}]
        },
        onLoad: false,
        errorMessage: {},
        onLoadSave: false,
      },
      tableObjects: [],
      modal: {
        search: this.$route.query.condition ? this.$route.query.condition : "",
        action: "",
        visible: false,
        onLoad: false,
        errorMessage: {},
        title: '',
        data: {}
      },
      statusOpts: [{ label: "Active", value: "active" }, { label: "Inactive", value: "inactive" }],
      sourceTypeOpt: [{ label: "Query", value: "query" }, { label: "JSON", value: "json" }],
    };
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    filteredConditions() {
      const list = this.field.data?.workflow_condition;
      if (!Array.isArray(list)) return [];
      const q = (this.field.search || '').trim().toLowerCase();
      if (!q) return list;
      return list.filter(item => (item.condition || '').toLowerCase().includes(q));
    },
    // modal.action 'create' -> add-condition, 'edit' -> edit-condition
    canSaveCondition() {
      if (this.modal.action === 'create') return this.hasAnyPermission('workflows-add-condition');
      if (this.modal.action === 'edit') return this.hasAnyPermission('workflows-edit-condition');
      return false;
    },
  },
  mounted() {
    if (this.hasAnyPermission('workflows-view')) {
      this.fetchWorkflowData();
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    async fetchWorkflowData() {
      this.field.onLoad = true
      try {
        const response = await api(this, workflowService.detail(this.$route.params.id), false);
        if (response.data && Array.isArray(response.data.workflow_condition)) {
          response.data.workflow_condition.sort((a, b) => 
            (a.condition || '').localeCompare(b.condition || '')
          );
        }
        this.field.data = response.data;
        
        // Default source_type to json
        if (!this.field.data.source_type || this.field.data.source_type === 'query') {
          this.field.data.source_type = 'json';
        }

        // Auto-format JSON if possible
        if (this.field.data.source) {
          try {
            const obj = typeof this.field.data.source === 'string' 
              ? JSON.parse(this.field.data.source) 
              : this.field.data.source;
            this.field.data.source = JSON.stringify(obj, null, 2);
          } catch (e) {
            // Keep as is if not valid JSON
          }
        }

        console.log('fetchWorkflowData', this.field.data.workflow_condition)
      } catch (error) {
        this.field.data = [];
      } finally {
        this.field.onLoad = false
      }
    },
    beautifyJson() {
      try {
        const obj = JSON.parse(this.field.data.source);
        this.field.data.source = JSON.stringify(obj, null, 2);
        delete this.field.errorMessage['source'];
      } catch (e) {
        this.$toastNotifPrime('error', "Invalid JSON", "Could not format the source because it's not a valid JSON string");
      }
    },
    save() {
      let isValid = true
      const requiredField = [{ key: "description", message: "Description" }, { key: "source", message: "Source" }, { key: "source_type", message: "Source Type" }, { key: "status", message: "Status" }]
      requiredField.forEach((val) => {
        if (!this.field.data[val.key] || (typeof this.field.data[val.key] === 'string' && this.field.data[val.key].trim() === '')) {
          this.field.errorMessage[val.key] = `${val.message} is required`
          isValid = false
        }
      })

      // JSON Validation
      if (isValid && this.field.data.source) {
        try {
          JSON.parse(this.field.data.source);
        } catch (e) {
          this.field.errorMessage['source'] = "Source must be a valid JSON string";
          isValid = false;
        }
      }

      if (!isValid) {
        this.$toastNotifPrime('error', "Validation Failed", "There field is empty or contain invalid data");
        return false
      }

      this.field.onLoadSave = true
      setTimeout(async () => {
        try {
          await api(this, workflowService.update(this.field.data.id, this.field.data))
          this.fetchWorkflowData()
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.field.onLoadSave = false
        }
      }, 500)
    },

    openAddModal() {
      this.modal = {
        visible: true,
        action: "create",
        title: "Add Condition",
        data: { wf_code: this.field.data.code, condition: "", condition_params: {} },
        onLoad: false,
        errorMessage: {}
      }
    },
    openEditModal(item) {
      console.log("openEditModal", item)
      this.modal = {
        visible: true,
        action: "edit",
        title: "Edit Condition",
        data: { ...item },
        onLoad: false,
        errorMessage: {}
      }
    },
    async saveCond() {
      if (!this.modal.data.condition || this.modal.data.condition.trim() === '') {
        this.modal.errorMessage.condition = "Condition is required."
        this.$toastNotifPrime('error', "Validation Failed", this.modal.errorMessage.condition);
        return false
      }
      this.field.onLoad = true
      this.modal.onLoad = true;
      // !field.onLoad || !field.onLoadSave
      setTimeout(async () => {
        try {
          if (this.modal.action === 'create') {
            await api(this, workflowService.addCondition(this.modal.data));
          } else if (this.modal.action === 'edit') {
            await api(this, workflowService.editCondition(this.modal.data.id, this.modal.data))
          }

          this.modal.data = {}
          this.modal.visible = false
          await this.fetchWorkflowData();
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modal.onLoad = false;
        }
      }, 500)
    },
    RemoveCondition(id) {
      this.confirmDialog("You won't be able to revert this!", "remove it").then((result) => {
        if (result.isConfirmed) {
          api(this, workflowService.removeCondition(id)).then(() => {
            this.fetchWorkflowData()
          }).catch(() => {});
        }
      });
    },
    handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        if (typeof errorData === 'object' && errorData !== null) {
          for (const key in errorData) {
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const match = key.match(/^items\.(\d+)\.(.+)$/);
              if (match) {
                error.response.data.data[key].forEach(message => {
                  this.$toastNotifPrime('error', error.response.data.message, `${message} in row ${parseInt(match[1]) + 1}`)
                })
              } else {
                this.$toastNotifPrime('error', error.response.data.message, errorData[key]);
                // errorData[key].forEach(message => {
                //   this.$toastNotifPrime('error', error.response.data.message, message);
                // });
              }
            }
          }
        }
      }
    },
    // cancelEdit() {
    //   this.$router.push({ name: "WorkFlow" });
    // },
  },
};
</script>
